
var externalExtensions = [

// First is the path to extension's entry point,
// Second (and all others) are the extension IDs.
{
  src: './extensions/Assistant/index.js',
  ids: ['Autodesk.Assistant']
},
{
  src: './extensions/TandemAssistant/index.js',
  ids: ['Autodesk.Tandem.Assistant']
},
{
  src: './extensions/Section/Section.js',
  ids: ['Autodesk.Tandem.Section']
},
{
  src: './extensions/DtCompGeom/index.js',
  ids: ['Autodesk.Tandem.DtCompGeom']
},
{
  src: './extensions/Edit2D/Edit2D.js',
  ids: ['Autodesk.Tandem.Edit2D']
},
{
  src: './extensions/VisualClusters/VisualClusters.js',
  ids: ['Autodesk.Tandem.VisualClusters']
},
{
  src: './extensions/Measure/Measure.js',
  ids: ['Autodesk.Tandem.Measure']
},
{
  src: './extensions/ViewCubeUi/ViewCubeUi.js',
  ids: ['Autodesk.Tandem.ViewCubeUi']
},
{
  src: './extensions/ModelAlignmentWrapper/ModelAlignmentWrapper.js',
  ids: ['Autodesk.Tandem.ModelAlignmentWrapper']
}
// {
//     src: './extensions/ModelEditor/index.js',
//     ids: ['Autodesk.ModelEditor'],
// },
];

function getExtensionEntryKey(ee) {
  if (ee.key) {
    return ee.key;
  } else {
    // Given ee.src == './extensions/Something/file.js'
    // then key == 'Something'
    let key = ee.src.split('/')[2];
    return key;
  }
}

module.exports = {
  externalExtensions,
  getExtensionEntryKey
};